<script>
	import { getContext } from "svelte";
	import { tweened } from "svelte/motion";
	import { animationParameters } from "../constants";

	const { yScale, padding, custom } = getContext("LayerCake");

	export let labelMain;
	export let labelSub = "";

	$: top = $yScale(0);
	const tTop = tweened(top, animationParameters);
	$: tTop.set(top);
</script>

<div
	class="baseline-label"
	style:left={-($custom.marginLeft + $padding.left) + "px"}
	style:top={$tTop + "%"}
	style:width={$custom.marginLeft + "px"}
>
	<div class="text">
		<div class="label-main">
			{@html labelMain}
		</div>
		<div class="label-sub">
			{@html labelSub}
		</div>
	</div>
	<div class="arrow" />
</div>

<style lang="scss">
	@import "../main.scss";

	.baseline-label {
		position: absolute;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
		column-gap: 7px;
		font-size: $fs-chart-l;
		line-height: $lh-chart-l;
		transform: translate(0, -50%);
		padding-right: 8px;
		opacity: 0.7;
	}

	// <= small tablets
	@media (max-width: $breakpoint-tablet-s) {
		.baseline-label {
			display: none;
		}
	}

	.label-main {
		font-weight: $medium;
		margin-bottom: 5px;
	}

	.arrow {
		width: 0;
		height: 0;
		border-top: 6px solid transparent;
		border-bottom: 6px solid transparent;

		border-left: 6px solid $black;
	}

	.arrow img {
		width: 20px;
		transform: scale(1, 1) rotate(225deg);
	}
</style>
